import { Channel } from '@weave/schema-gen-ts/dist/schemas/comm-preference/shared/v1/enums.pb';
import { useGetPreference } from '@frontend/api-comm-preference';
import { getUser } from '@frontend/auth-helpers';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { FaxEmailTable } from './fax-email-table';

type Props = {
  locationId: string;
  locationName: string;
};

export const FaxEmailLocationAccordion = ({ locationId, locationName }: Props) => {
  const user = getUser();

  const { data: emailPreferences, refetch } = useGetPreference(
    {
      userChannelAddress: user?.username,
      channel: Channel.CHANNEL_WEAVE_EMAIL_UPDATE,
      locationId,
    },
    {},
    true
  );

  return (
    <div
      css={{
        width: '100%',
        borderRadius: theme.borderRadius.small,
        boxShadow: theme.shadows.light,
      }}
    >
      <Accordion.Item value={locationId}>
        <Accordion.Header>
          <Accordion.Header.Location title={locationName} />
        </Accordion.Header>
        <Accordion.Body>
          <FaxEmailTable locationId={locationId} emailPreferences={emailPreferences} refetch={refetch} />
        </Accordion.Body>
      </Accordion.Item>
    </div>
  );
};
